module.exports = __webpack_public_path__ + "1c5b5c26f089f8a1c8c06f0221e878a2.png";